import { useContext } from "react";
import { AppInfo } from "./AppInfo";
import { AppInfoContext } from "./AppInfoContext";

export const useAppInfo = (): AppInfo => {
  const appInfo = useContext(AppInfoContext);
  if (appInfo == null) {
    throw new Error("useAppInfo must be used within a AppInfoProvider");
  }

  return appInfo;
};

export const useAppInfoOrNull = (): AppInfo | null => {
  return useContext(AppInfoContext);
};
